import { commonViewTexts } from '../common';
import { createDialogCommonViewTexts } from './create-dialog-common';

const targetName = commonViewTexts.koumuten;

export const createNewKoumutenDialogViewTexts = {
  title: `${targetName} 新規登録`,
  descriptions: createDialogCommonViewTexts.messageGenerator(targetName),
  labels: {
    registerer: commonViewTexts.registerer,
    koumutenName: `${targetName}名`
  }
} as const;
